export default {
  button: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    color: 'white',
  },
  buttonBlue: {
    background: '#2196f3',
  },
  buttonRed: {
    background: '#e6112b',
  },
  buttonSuccess: {
    background: '#34cf0c',
  }
};




// WEBPACK FOOTER //
// ./src/components/OrdersDataTable/styles.js